export default {
      id: "weve-usage",
      viewBox: "0 0 512 308",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#weve-usage",
      toString: function () {
        return this.url;
      }
    }